import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DynamicLinkService {
  private dynamicLinkApiUrl =
    'https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=' +
    environment.firebase.apiKey;

  constructor(private http: HttpClient) {}

  generateDynamicLink(challengeId: string) {
    const requestBody = {
      dynamicLinkInfo: {
        domainUriPrefix: environment.dynamicLink.customDeepLinkDomain, // Custom domain you configured in Firebase
        link: `${environment.dynamicLink.domainUriPrefix}/joinChallenge?challengeId=${challengeId}`,
        androidInfo: {
          androidPackageName: environment.dynamicLink.androidPackageId, // Android package name
          androidFallbackLink: `${environment.dynamicLink.domainUriPrefix}/joinChallenge?challengeId=${challengeId}`,
        },
        iosInfo: {
          iosBundleId: environment.dynamicLink.iosBundleId, // iOS bundle ID
          iosFallbackLink: `${environment.dynamicLink.domainUriPrefix}/joinChallenge?challengeId=${challengeId}`,
        },
      },
    };

    return this.http.post(this.dynamicLinkApiUrl, requestBody);
  }
}
